const PREFIX = 'FACILITY_LOCATOR_MAP_';

export const SET_FACILITIES = `${PREFIX}SET_FACILITES`;
export const TOGGLE_SELECTED_FACILITY = `${PREFIX}SET_SELECTED_FACILITY`;
export const SET_FACILITIES_IN_MAP_BOUNDS = `${PREFIX}SET_FACILITIES_IN_MAP_BOUNDS`;
export const SET_LIST_VIEW_FOR_MAP = `${PREFIX}SET_LIST_VIEW_FOR_MAP`;
